var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyDnaHeartIcon = function SvgWhyDnaHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2223C14.6821 0.789268 4.8438 8.91292 4.71436 17.67C4.71436 30.7069 20.3128 41.4076 24 41.4076C27.6872 41.4076 43.2858 30.7069 43.2858 17.67C43.1563 8.91292 33.318 0.789268 24 12.2223Z",
    fill: "#FEECAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11792 14.7425C7.06834 7.32158 15.7386 2.08542 23.9999 12.2219C33.3179 0.788902 43.1562 8.91255 43.2857 17.6697C43.2857 30.7066 27.6871 41.4072 23.9999 41.4072C21.7947 41.4072 15.3289 37.5797 10.4876 31.7139",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7144 22.4571H27.0858L22.4572 28.6286L16.2858 17.8286L11.6572 24H4.71436",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhyDnaHeartIcon;